<template>
  <div>
    <br/>
    <a :href="downloadApplicationUrl" target="_blank" class="color-primary">
      Application No. {{ `${variableSymbol} ${person.name}${person.surname}` }}
    </a>
  </div>
 </template>

<script>
export default {
  name: 'DownloadApplication',
  props: {
    path: { required: true, type: String },
    person: { required: true, type: Object },
    variableSymbol: { required: true, type: String },
  },
  computed: {
    downloadApplicationUrl() {
      const origin = process.env.NODE_ENV === 'production' ? window.location.origin : 'https://unionweb.astondev.sk';

      return origin + process.env.VUE_APP_API_CONTEXT + this.path;
    },
  },
};
</script>
